import { Severity } from '../api/governance/violationRule.model';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const SeveritySelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.Severity.toString()}-${Severity.high}`,
    value: Severity.high,
    displayName: Severity.high,
    filterType: FilterTypesEnum.Severity,
    categoryName: FilterTypesEnum.Severity.toString(),
  },
  {
    id: `${FilterTypesEnum.Severity.toString()}-${Severity.medium}`,
    value: Severity.medium,
    displayName: Severity.medium,
    filterType: FilterTypesEnum.Severity,
    categoryName: FilterTypesEnum.Severity.toString(),
  },
  {
    id: `${FilterTypesEnum.Severity.toString()}-${Severity.low}`,
    value: Severity.low,
    displayName: Severity.low,
    filterType: FilterTypesEnum.Severity,
    categoryName: FilterTypesEnum.Severity.toString(),
  },
];
